import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, switchMap, take, throwError } from 'rxjs';

import { AuthService } from '@auth0/auth0-angular';

import { SKIP_AUTH0 } from '../tokens/http-context.tokens';
import { IZA_CONFIG } from '../iza-config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(IZA_CONFIG);
  // ahri is exclusive to the Iza (host never calls it); the autosync URL is SHARED
  // with the host, so scoping to ahri only avoids attaching an Auth0 token to the
  // host's own autosync request. The Iza's own autosync call uses SKIP_AUTH0 +
  // izaAutosyncInterceptor's x-api-key, so it never needed this interceptor.
  const isAhriUrl = req.url.startsWith(config.ahriApiUrl);

  if (!isAhriUrl || req.context.get(SKIP_AUTH0)) {
    return next(req);
  }

  const auth0: AuthService = inject(AuthService);

  return auth0.idTokenClaims$.pipe(
    take(1),
    switchMap(token => {
      const requestWithToken = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token?.__raw}`,
        },
      });

      return next(requestWithToken);
    }),
    catchError(error => {
      console.error('Falha de autenticação:', error);

      auth0.logout({
        logoutParams: { returnTo: globalThis.location.origin },
      });

      return throwError(() => error);
    })
  );
};
